<template>
  <v-col :cols="$vuetify.breakpoint.smAndUp ? 4 : 12">
    <v-hover v-slot:default="{hover}">
      <v-card
        outlined
        style="width: 100%; height: 300px;"
        :elevation="hover ? 12 : 1"
        :to="link"
      >
        <div style="text-align:center">
          <v-list-item three-line>
            <v-list-item-content>
              <v-card-title class="headline justify-center font-weight-bold">
                {{ title }}
              </v-card-title>
              <v-icon :color="color" size="120px">{{ icon }}</v-icon>
              <v-card-text v-html="text" />
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-card>
    </v-hover>
  </v-col>
</template>

<script>
export default {
  name: 'DashboardMenu',
  props: {
    color: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
  },
  data: () => ({}),
}
</script>
